
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Nyissa meg a böngészője menüjét`,
's182ab2d6c997515f': `Adja hozzá a kezdőképernyőjéhez a teljes élmény és a könnyű hozzáférés érdekében.`,
's1b9047d53d9f9d22': `2) Nyomja meg a Megosztás gombot a navigációs sávban`,
's2d90afa5dcca2c0e': `3) Görgessen le a "Hozzáadás a kezdőképernyőhöz" lehetőséghez`,
's37a9e8aec5713460': `Több`,
's4593f304dac8848c': `2) Koppintson a "Hozzáadás a kezdőképernyőhöz" lehetőségre`,
's54cfbb14f46396d4': `1) Nyissa meg a fő böngészőjében`,
's6196153c4b0c1ea0': `Telepítés`,
's922329d6f6213590': `Hozzáadás a Dock-hoz`,
'sa5ef80b4bb9b39f8': `Kevesebb`,
'sa7551383d1897fcc': `2) Nyomja meg a Hozzáadás a Dock-hoz gombot`,
'sba52286c21552a4e': `Telepítse eszközére a teljes élmény és a könnyű hozzáférés érdekében.`,
'sc79fd7641eb9a975': `Útmutató elrejtése`,
'scdaf4bbff76674c8': `Hozzáadás a kezdőképernyőhöz`,
'se740f75b95a51807': `Adja hozzá a Dock-hoz a teljes élmény és a könnyű hozzáférés érdekében.`,
'sfea652f6580ff086': `Ez az oldal alkalmazásfunkcióval rendelkezik.`,
    };
  